module.exports = __webpack_public_path__ + "static/media/common-header-bg.7448af66.png";